import React from 'react';
import {
  Box,
  Button,
  SpaceBetween,
  Table,
  TableProps,
} from '@cloudscape-design/components';
import { PlayersPreset } from '../../api';

interface PlayersPresetsProps {
  presets: PlayersPreset[];
  onRemovePreset?: (preset: PlayersPreset) => void;
  onPresetSelect?: (preset: PlayersPreset) => void;
}

export const PlayersPresets: React.FC<PlayersPresetsProps> = ({
  presets,
  onRemovePreset: removePreset,
  onPresetSelect,
}) => {
  const columnDefinitions: TableProps.ColumnDefinition<PlayersPreset>[] = [
    {
      id: 'players',
      header: 'Players',
      ariaLabel: () => 'Preset players',
      cell: (preset) => preset.players.map((p) => p.name).join(', '),
    },
    {
      id: 'actions',
      header: 'Actions',
      maxWidth: 44,
      cell: (preset) => {
        return (
          <SpaceBetween size="s" direction="horizontal">
            <Button
              variant="icon"
              formAction="none"
              ariaLabel="Apply preset"
              iconName="check"
              onClick={() => onPresetSelect?.(preset)}
            />
            <Button
              variant="icon"
              formAction="none"
              ariaLabel="Delete preset"
              iconName="close"
              onClick={() => removePreset?.(preset)}
            />
          </SpaceBetween>
        );
      },
    },
  ];

  return (
    <>
      <Box variant="h3">Players Presets</Box>
      <Table
        columnDefinitions={columnDefinitions}
        variant="embedded"
        items={presets}
        empty={
          <Box textAlign="center" color="inherit">
            <b>No presets</b>
            <Box padding={{ bottom: 's' }} variant="p" color="inherit">
              Please use "Save as preset" button to add new preset.
            </Box>
          </Box>
        }
      />
    </>
  );
};
